import { useCallback } from 'react';
import Cookies from 'js-cookie';
import { useLocale } from '@hooks/useLocale';
import { BC_CART_COOKIE_NAME } from '@adapters/bigcommerce/constants';
import { HookError } from '@adapters/bigcommerce/errorHandlers';
import type { Cart } from '@adapters/bigcommerce/types/cart';

export const getCartFetcher = async (
  locale: string,
  validateCart: boolean
): Promise<Cart | null> => {
  const cartId = Cookies.get(BC_CART_COOKIE_NAME);

  if (!cartId) return null;

  const apiUrl = validateCart ? '/api/cart/validate' : '/api/cart';
  const httpMethod = validateCart ? 'POST' : 'GET';

  const cartResponse = await fetch(apiUrl, {
    method: httpMethod,
    headers: {
      'Accept-Language': locale,
    },
  });

  const { data } = await cartResponse.json();

  return data;
};

const useCart = () => {
  const locale = useLocale();
  if (!locale)
    throw new HookError('Locale must be specified to add item to cart');

  const getCart = useCallback(() => getCartFetcher(locale, false), [locale]);

  const validateCart = useCallback(
    () => getCartFetcher(locale, true),
    [locale]
  );

  return { getCart, validateCart };
};

export default useCart;
